const rootUrl = window.location.host
let apiRoot = ''
console.log({rootUrl})
switch (rootUrl) {
    case 'localcode.classba.cn':
        apiRoot = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'dev-oss.classba.com.cn'
        break
    default:
        apiRoot = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'check-video.classba.cn'
        break
}

export { apiRoot }